// context/UserContext.js
import React, { createContext, useState } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // تابعی برای دریافت اطلاعات کاربر از سرور
  const fetchUser = async () => {
    const token = localStorage.getItem("userToken");
    if (!token) return;

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/User/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) throw new Error("Unauthorized");

      const data = await res.json();

      const fetchedUser = {
        username: data.username,
        avatar:
          `${process.env.REACT_APP_API_URL}${data.imageAddress}` ||
          "https://images.unsplash.com/photo-1488161628813-04466f872be2?fm=jpg&q=60&w=3000",
        isAdmin: data.isAdmin,
      };

      setUser(fetchedUser);
      localStorage.setItem("user", JSON.stringify(fetchedUser));
    } catch (err) {
      console.error("Error fetching user:", err);
      setUser(null);
      localStorage.removeItem("userToken");
      localStorage.removeItem("user");
    }
  };

  return (
    <UserContext.Provider value={{ user, setUser, fetchUser }}>
      {children}
    </UserContext.Provider>
  );
};
